import type { FlexProps } from '@chakra-ui/react';
import { Box, Divider, Flex } from '@chakra-ui/react';
import type { InfoProps } from '@ui/components/Info';
import Info from '@ui/components/Info';
import { useStakedNfts } from '@ui/hooks/useCruisers';
import useFarmAprs from '@ui/hooks/useFarmAprs';
import { useTranslations } from '@ui/i18n';
import React from 'react';

import { useGardenModalStore } from '../useGardenModalStore';

const GardenBoostMoreDetail = ({ ...props }: FlexProps) => {
  const t = useTranslations();

  const { boostMultiplier } = useFarmAprs();
  const { type: gardenType } = useGardenModalStore();
  const { data: cruisers } = useStakedNfts(gardenType);

  const helpersTotal = cruisers ? cruisers.length : undefined;

  const helpersLimit = 5;

  const helperBoostMultiplier = cruisers
    ? cruisers.reduce((prev, curr) => curr.multiplier + prev, 0)
    : undefined;

  const totalBoostMultiplier =
    boostMultiplier !== undefined && helperBoostMultiplier !== undefined
      ? boostMultiplier + helperBoostMultiplier
      : undefined;

  return (
    <Flex flexDir="column" {...props}>
      <GardenBoostInfo
        title={t('Watering Boost')}
        value={`${boostMultiplier?.toFixed(3)}x`}
      />
      <GardenBoostInfo
        mt="16px"
        title={`${t('Helper boost')} ${
          helpersTotal !== undefined && helpersLimit !== undefined
            ? `(${helpersTotal}/${helpersLimit})`
            : ''
        }`}
        value={
          helperBoostMultiplier !== undefined
            ? `+${helperBoostMultiplier?.toFixed(3)}x`
            : undefined
        }
      />
      <Divider my="12px" />
      <GardenBoostInfo
        title={t('Total boost')}
        value={
          totalBoostMultiplier !== undefined
            ? `${Math.min(totalBoostMultiplier, 2)?.toFixed(3)}x`
            : undefined
        }
      />
    </Flex>
  );
};

export default GardenBoostMoreDetail;

const GardenBoostInfo = ({ title, value, ...props }: InfoProps) => {
  return (
    <Info
      {...props}
      title={<Box textStyle="bodySmall">{title}</Box>}
      value={<Box textStyle="ctaCopy">{value}</Box>}
    />
  );
};
